// @flow
import { post } from '../../../api/api';

export default async function trackCoachOnboardingEvent(key: string) {
    return await post(`/v5/trackCoachOnboarding`, { key: key });
}
